/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Label_AddressInputs */

const vi_receipt_label_address = /** @type {(inputs: Receipt_Label_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ`)
};

/**

* @param {Receipt_Label_AddressInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_label_address = /** @type {((inputs?: Receipt_Label_AddressInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Label_AddressInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_label_address(inputs)
});